export const painPoints: string[] = [
  'Llegás a la clase sin saber exactamente qué secuencia vas a dar hoy.',
  'Tus alumnos no progresan porque no tenés una estructura clara de nivel a nivel.',
  'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo.',
  'Siempre los mismos 10 o 15 ejercicios porque no tenés más material listo.',
  'No podés justificar un aumento de precio porque no tenés un sistema profesional visible.',
  'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde.',
  'Tenés alumnos de distintos niveles juntos y la clase se convierte en un caos.',
  'Fin de mes y los alumnos se van sin avisar porque la comunicación es inconsistente.',
]
